export default __webpack_public_path__ + "static/media/sports.5cba63f7.svg";